import { Objects } from '../object-definitions'

export namespace UXConfigEstablishment {
    export async function getSummary(
        getSummaryQuery: (establishmentID: string) => Parse.Query<Objects.UXConfigEstablishment.Parse>,
        establishmentID: string,
        useMasterKey: boolean
    ) {
        const query = getSummaryQuery(establishmentID)

        let uxConfigEstablishments
        if (useMasterKey) {
            uxConfigEstablishments = await query.find({ useMasterKey: true })
        } else {
            uxConfigEstablishments = await query.find()
        }

        return uxConfigEstablishments
            .sort((a, b) => {
                return b.get('sort') - a.get('sort')
            })
            .filter((uxConfigEstablishment) => {
                return uxConfigEstablishment.get('isEnabled') && uxConfigEstablishment.get('uxConfig').get('isEnabled')
            })
            .reduce<Omit<Partial<Objects.UXConfig.Attributes>, 'name' | 'isEnabled'>>((acc, uxConfigEstablishment) => {
                const uxConfig = uxConfigEstablishment.get('uxConfig')

                if (acc.preferredListingFinderComingSoonTemplateID === undefined && uxConfig.get('preferredListingFinderComingSoonTemplateID') !== undefined) {
                    acc.preferredListingFinderComingSoonTemplateID = uxConfig.get('preferredListingFinderComingSoonTemplateID')
                }

                if (acc.preferredListingFinderJustListedTemplateID === undefined && uxConfig.get('preferredListingFinderJustListedTemplateID') !== undefined) {
                    acc.preferredListingFinderJustListedTemplateID = uxConfig.get('preferredListingFinderJustListedTemplateID')
                }

                if (acc.preferredListingFinderJustSoldTemplateID === undefined && uxConfig.get('preferredListingFinderJustSoldTemplateID') !== undefined) {
                    acc.preferredListingFinderJustSoldTemplateID = uxConfig.get('preferredListingFinderJustSoldTemplateID')
                }

                if (acc.preferredListingFinderPendingTemplateID === undefined && uxConfig.get('preferredListingFinderPendingTemplateID') !== undefined) {
                    acc.preferredListingFinderPendingTemplateID = uxConfig.get('preferredListingFinderPendingTemplateID')
                }

                if (
                    acc.preferredListingFinderUnderContractTemplateID === undefined &&
                    uxConfig.get('preferredListingFinderUnderContractTemplateID') !== undefined
                ) {
                    acc.preferredListingFinderUnderContractTemplateID = uxConfig.get('preferredListingFinderUnderContractTemplateID')
                }

                if (acc.topTemplateTags === undefined && uxConfig.get('topTemplateTags') !== undefined) {
                    acc.topTemplateTags = uxConfig.get('topTemplateTags')
                }

                if (acc.isWatermarklessEnabled === undefined && uxConfig.get('isWatermarklessEnabled') !== undefined) {
                    acc.isWatermarklessEnabled = uxConfig.get('isWatermarklessEnabled')
                }

                return acc
            }, {})
    }
}
